export default __webpack_public_path__ + "static/media/330_dummy2016-personaltrainer01-mobile-de.e7dc225c.png";